/**
 * Which special (if any) is on one hole card, as the viewer may see it:
 * the special itself, "unrevealed" for the holder's own face-down special
 * (until the 4 corners) or an opponent's special seen through Oracle,
 * Soothsayer or Omnipotent (that there is one, not which), or — through
 * Spy — which special an opponent holds on a hidden card. Each special is drawn on its own card's side of the hand:
 * left card's to the left, right card's to the right.
 */
import { isHiddenCard, isMaskedCard, type SpecialCardType, type ViewerFacingCard } from '@pokercubed/shared';

export function specialOfCard(card: ViewerFacingCard | null | undefined): SpecialCardType | 'unrevealed' | undefined {
  if (!card || isMaskedCard(card)) return undefined;
  if (isHiddenCard(card)) return card.special;
  return card.special ?? (card.unrevealedSpecial ? 'unrevealed' : undefined);
}
